export const endpoints = {
  exportPrices: "export/prices/",
  exportPricesWithId: id => `export/prices/id/${id}`
};



// WEBPACK FOOTER //
// ./src/utils/constants.js